import axiosInstance from '../utils/axiosInstance';

export async function adminApproveRejectLeave(leaveId, status, admin_comment = "") {
  const { data } = await axiosInstance.put(`/leaves/${leaveId}/approve`, {
    status,
    admin_comment,
  });
  return data;
}

export async function adminUpdateLeave(leaveId, payload) {
  const { data } = await axiosInstance.put(`/leaves/${leaveId}`, payload);
  return data;
}

export async function adminApplyLeave(formDataObj) {
  const { data } = await axiosInstance.post(
    "/leaves/admin-leave-apply",
    formDataObj,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return data;
}

export async function fetchAdminLeaveDashboard() {
  const { data } = await axiosInstance.get(`/leaves/admin-dashboard`);
  return data;
}

export async function fetchAllLeaveRequests() {
  const { data } = await axiosInstance.get("/leaves");
  return data;
}

// --- LEAVE: Entitlement for an employee ---
export async function getEmployeeLeaveDashboard(employeeId) {
  if(employeeId?.employeeId){
  const { data } = await axiosInstance.get(`/leaves/employee-dashboard/${employeeId.employeeId}`);
  return data;
  }else{
  const { data } = await axiosInstance.get(`/leaves/employee-dashboard`);
  return data;
  }
}

// --- LEAVE: All leave requests for logged-in employee ---
export async function getEmployeeLeaveRequests(employeeId) {
  if(employeeId.employeeId){
 const { data } = await axiosInstance.get(`/leaves/leave-requests/${employeeId.employeeId}`);
  return data;
  }else{
  const { data } = await axiosInstance.get(`/leaves/leave-requests`);
  return data;
  }
}

export const submitLeaveRequest = async (payload, file, employeeId) => {
  const form = new FormData();
  Object.keys(payload).forEach((key) => {
    form.append(key, payload[key]);
  });

  if (file) form.append("document", file);
  if(employeeId.employeeId){
  const { data } = await axiosInstance.post(`/leaves/leave-request/${employeeId.employeeId}`, form);
  return data;
  }else{
  const { data } = await axiosInstance.post(`/leaves/leave-request`, form);
  return data;
  }

};

// --- LEAVE: Cancel leave request ---
export async function cancelLeaveRequest(leaveId, cancellation_reason, employeeId) {
  if(employeeId.employeeId){
  const { data } = await axiosInstance.put(`/leaves/${leaveId}/cancel/${employeeId.employeeId}`, {
    cancellation_reason
  });
  return data;
  }else{
  const { data } = await axiosInstance.put(`/leaves/${leaveId}/cancel`, {
    cancellation_reason
  });
  return data;
  }
}

export async function viewDocument(s3key) {
  const { data } = await axiosInstance.get(`/leaves/document`, {
    params: {key: s3key}
  });
  return data;
}

export async function fetchEmployeeAssignedLeaves(employeeId) {
  if(employeeId){
  const { data } = await axiosInstance.get("/leaves/employee-leaves", {params : {employeeId}});
  return data;
  } else{
  const { data } = await axiosInstance.get("/leaves/employee-leaves");
  console.log("Data ", data);
  
  return data;
  }
}

// --- LEAVE: Policies applicable to the logged-in employee (Help Center) ---
export async function fetchEmployeeLeavePolicies(employeeId) {
  const { data } = await axiosInstance.get("/leaves/leave-policies", {
    params: employeeId ? { employeeId } : undefined,
  });
  return data;
}

export async function fetchEmployeeEncashmentRequests() {
  const { data } = await axiosInstance.get(`/leaves/encash`);
  return data;
}

export async function approveLeaveEncashmentRequest(payload) {
  const { data } = await axiosInstance.post(`/leaves/leave-encashment-requests/accept`, payload);
  return data;
}

export async function rejectLeaveEncashmentRequest(payload) {
  const { data } = await axiosInstance.post(`/leaves/leave-encashment-requests/reject`, payload);
  return data;
}